
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdelantosPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/adelantos/cuotas', { replace: true });
  }, [navigate]);

  return null;
}
